import React, { createContext, useContext, useState, useEffect } from "react";

const translations = {
  fr: {
    nav: { home: "Accueil", services: "Services", properties: "Logements", valley: "Vallée de Chamonix", contact: "Contact", rent: "Louer votre bien" },
    hero: {
      tagline: "Conciergerie premium — Chamonix Mont-Blanc",
      title: "Votre Sérénité,",
      titleAccent: "Notre Expertise.",
      subtitle: "Basée au cœur de la Vallée de Chamonix, MyHost gère vos locations de vacances de A à Z. Ne vous occupez de rien, nous gérons tout.",
      ctaPrimary: "Découvrir nos logements",
      ctaSecondary: "Confier mon bien",
      stats: { rating: "Note moyenne", reviews: "Avis clients", properties: "Logements gérés", service: "Assistance 7j/7" },
    },
    home: {
      promiseTitle: "Une Gestion Premium pour des Revenus Optimisés",
      promiseText: "Service sur-mesure pour maximiser la rentabilité de votre bien tout en garantissant une expérience inoubliable aux voyageurs.",
      p1: "Optimisation des revenus", p1d: "Stratégie tarifaire adaptée à vos objectifs personnels pour maximiser vos réservations.",
      p2: "Valorisation immobilière", p2d: "Conseils en aménagement et décoration, shooting photo professionnel inclus.",
      p3: "Communication d'exception", p3d: "Un suivi réactif, professionnel, et une assistance voyageurs et propriétaires 7j/7.",
      featuredTitle: "Nos logements coups de cœur",
      featuredSub: "Une sélection d'hébergements d'exception au cœur de la vallée",
      seeAll: "Voir tous les logements",
      ctaTitle: "Prêt à confier votre bien ?",
      ctaText: "Estimation locative gratuite et sans engagement.",
      ctaBtn: "Demander une estimation",
    },
    services: {
      title: "Nos Services",
      subtitle: "Une gestion « clés en main » pensée pour l'excellence",
      intro: "Nous prenons en charge l'intégralité du processus locatif pour que vous n'ayez rien à gérer.",
      items: [
        { t: "Création et Gestion d'annonces", d: "Rédaction optimisée, shooting photo professionnel inclus, diffusion multi-plateformes." },
        { t: "Stratégie tarifaire", d: "Calendrier et prix dynamiques pour maximiser vos réservations tout au long de l'année." },
        { t: "Accueil et Départ", d: "Check-in et check-out soignés, remise des clés, état des lieux." },
        { t: "Entretien complet", d: "Nettoyage professionnel entre chaque séjour et suivi technique du bien." },
        { t: "Estimation locative", d: "Évaluation gratuite du potentiel locatif de votre propriété." },
        { t: "Relation client 7j/7", d: "Assistance voyageurs et propriétaires disponible tous les jours." },
      ],
      checkinTag: "Prestation à la carte",
      checkinTitle: "Check-in / Check-out à la carte",
      checkinHook: "Vous gérez vous-même votre location ? Confiez-nous uniquement l'accueil de vos voyageurs.",
      checkinBody: "Pas besoin d'un mandat de gestion complet pour profiter de notre savoir-faire. Nous proposons un service ponctuel d'accueil et de départ pour les propriétaires indépendants — idéal lorsque vous êtes absent, en déplacement, ou que vous souhaitez offrir une expérience hôtelière à vos voyageurs.",
      checkinPoints: [
        "Accueil personnalisé des voyageurs et remise des clés",
        "Présentation du logement et conseils sur la vallée",
        "État des lieux d'entrée et de sortie",
        "Disponibilité 7j/7, y compris arrivées tardives",
        "Tarif transparent, sans engagement",
      ],
      checkinCta: "Demander un devis",
    },
    properties: {
      title: "Nos Logements",
      subtitle: "Des hébergements d'exception dans la Vallée de Chamonix",
      reviews: "avis", people: "pers.", book: "Réserver sur Airbnb", favorite: "Coup de cœur voyageurs",
      newBadge: "Nouveau",
      bookSoon: "Bientôt disponible",
      amenitiesTitle: "Équipements",
    },
    valley: {
      title: "La Vallée de Chamonix Mont-Blanc",
      subtitle: "Un territoire mythique, entre sommets légendaires et art de vivre alpin",
      intro: "Joyau des Alpes françaises, Chamonix offre un cadre unique mêlant aventure, nature et raffinement. Que ce soit en hiver pour le ski ou en été pour la randonnée, chaque saison révèle une nouvelle facette de la vallée.",
      activitiesTitle: "Incontournables et Activités",
      restaurantsTitle: "Tables à découvrir",
    },
    contact: {
      title: "Contactez-nous", subtitle: "Une question, un projet ? Nous vous répondons rapidement.",
      rentTitle: "Louer votre bien", rentSubtitle: "Maximisez vos revenus avec une conciergerie d'exception",
      rentIntro: "Confiez-nous votre bien et profitez d'une gestion premium sans contrainte. Estimation gratuite.",
      fName: "Nom complet", fEmail: "Email", fPhone: "Téléphone", fSubject: "Sujet", fMessage: "Votre message",
      fType: "Type de bien", fLocation: "Localisation", send: "Envoyer", sending: "Envoi…",
      success: "Message envoyé — nous vous répondons au plus vite.", error: "Une erreur est survenue. Réessayez.",
      info: "Nos coordonnées", phone: "Téléphone", email: "Email", location: "Vallée de Chamonix Mont-Blanc",
    },
    footer: {
      tagline: "Votre sérénité, notre expertise.",
      nav: "Navigation", contactT: "Contact", legal: "Mentions légales",
      rights: "Tous droits réservés.",
    },
    amen: {
      bath: "Baignoire", shower: "Douche", balcony: "Balcon", library: "Bibliothèque",
      kitchen: "Cuisine", wifi: "Wifi", raclette: "Raclette", fondue: "Fondue",
      parking: "Parking", central: "Central", view: "Vue panoramique", ev_parking: "Parking + Recharge élec.",
    },
  },
  en: {
    nav: { home: "Home", services: "Services", properties: "Rentals", valley: "Chamonix Valley", contact: "Contact", rent: "List your property" },
    hero: {
      tagline: "Premium concierge — Chamonix Mont-Blanc",
      title: "Your Peace of Mind,",
      titleAccent: "Our Expertise.",
      subtitle: "Based in the heart of the Chamonix Valley, MyHost manages your holiday rentals from A to Z. Sit back, we handle everything.",
      ctaPrimary: "Explore our rentals",
      ctaSecondary: "List my property",
      stats: { rating: "Average rating", reviews: "Guest reviews", properties: "Managed rentals", service: "7-day support" },
    },
    home: {
      promiseTitle: "Premium Management for Optimized Revenue",
      promiseText: "Tailor-made service to maximize your property's profitability while delivering an unforgettable guest experience.",
      p1: "Revenue optimization", p1d: "Pricing strategy adapted to your personal goals to maximize your bookings.",
      p2: "Property enhancement", p2d: "Interior design advice and professional photography included.",
      p3: "Exceptional communication", p3d: "Responsive, professional follow-up — 7-day support for guests and owners.",
      featuredTitle: "Our featured rentals",
      featuredSub: "A selection of exceptional stays in the heart of the valley",
      seeAll: "See all rentals",
      ctaTitle: "Ready to list your property?",
      ctaText: "Free rental estimate, no commitment.",
      ctaBtn: "Request an estimate",
    },
    services: {
      title: "Our Services", subtitle: "Turn-key management designed for excellence",
      intro: "We handle the entire rental process so you don't have to.",
      items: [
        { t: "Listing creation and management", d: "Optimized copy, professional photography included, multi-platform publishing." },
        { t: "Pricing strategy", d: "Dynamic pricing and calendar to maximize year-round bookings." },
        { t: "Check-in and Check-out", d: "Warm welcomes and smooth departures, key handover, inventory." },
        { t: "Complete maintenance", d: "Professional cleaning between each stay and technical monitoring." },
        { t: "Rental estimate", d: "Free assessment of your property's rental potential." },
        { t: "7-day client care", d: "Guest and owner support available every day." },
      ],
      checkinTag: "À la carte service",
      checkinTitle: "Check-in / Check-out à la carte",
      checkinHook: "Managing your own rental? Let us handle just the guest welcome.",
      checkinBody: "No need to sign a full management contract to enjoy our expertise. We offer a one-off check-in and check-out service for independent owners — ideal when you're away, traveling, or simply want to offer your guests a hotel-like experience.",
      checkinPoints: [
        "Personalized welcome and key handover",
        "Property tour and local valley tips",
        "Entry and exit inventory",
        "Available 7 days a week, including late arrivals",
        "Transparent pricing, no commitment",
      ],
      checkinCta: "Request a quote",
    },
    properties: {
      title: "Our Rentals", subtitle: "Exceptional stays in the Chamonix Valley",
      reviews: "reviews", people: "guests", book: "Book on Airbnb", favorite: "Guest favorite",
      newBadge: "New", bookSoon: "Coming soon", amenitiesTitle: "Amenities",
    },
    valley: {
      title: "The Chamonix Mont-Blanc Valley", subtitle: "A legendary territory, between iconic peaks and alpine living",
      intro: "A jewel of the French Alps, Chamonix offers a unique setting combining adventure, nature and refinement. Whether in winter for skiing or summer for hiking, each season reveals a new facet.",
      activitiesTitle: "Must-sees and Activities", restaurantsTitle: "Tables to discover",
    },
    contact: {
      title: "Contact us", subtitle: "A question, a project? We reply quickly.",
      rentTitle: "List your property", rentSubtitle: "Maximize your revenue with exceptional concierge service",
      rentIntro: "Entrust us with your property and enjoy premium, hassle-free management. Free estimate.",
      fName: "Full name", fEmail: "Email", fPhone: "Phone", fSubject: "Subject", fMessage: "Your message",
      fType: "Property type", fLocation: "Location", send: "Send", sending: "Sending…",
      success: "Message sent — we'll get back to you shortly.", error: "Something went wrong. Please try again.",
      info: "Our details", phone: "Phone", email: "Email", location: "Chamonix Mont-Blanc Valley",
    },
    footer: {
      tagline: "Your peace of mind, our expertise.",
      nav: "Navigation", contactT: "Contact", legal: "Legal",
      rights: "All rights reserved.",
    },
    amen: {
      bath: "Bathtub", shower: "Shower", balcony: "Balcony", library: "Library",
      kitchen: "Kitchen", wifi: "Wifi", raclette: "Raclette", fondue: "Fondue",
      parking: "Parking", central: "Central", view: "Panoramic view", ev_parking: "Parking + EV charger",
    },
  },
};

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("myhost_lang") || "fr");
  useEffect(() => { localStorage.setItem("myhost_lang", lang); document.documentElement.lang = lang; }, [lang]);
  const t = translations[lang];
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
